// The public domain (philsconversation.ch / www) shows the marketing homepage at "/" and "/de".
// app.philsconversation.ch and previews keep the client dashboard at "/", so the homepage stays at "/start" there.
export function isMarketingHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "philsconversation.ch" || h === "www.philsconversation.ch";
}
